import { Box } from 'components/Box';
import { Image } from 'components/Image/Image';
import { getStaticImageSrc } from 'utils/getImageSrc';

type Props = {
  isAmex?: boolean;
};

export function CreditCardBrandImage({ isAmex }: Props) {
  return (
    <Box
      component={Image}
      src={
        isAmex
          ? getStaticImageSrc('cc-amex.svg')
          : getStaticImageSrc('cc-other.svg')
      }
      alt=""
    />
  );
}
